<div class="layout-main">
  <div class="container-fluid">
    <nav *ngIf="loggedInUser && loggedInUser.company" class="navbar navbar-expand navbar-light bg-light mb-3 nav-style"
         id="breadcrumb-sf-1">
      <nav aria-label="breadcrumb" class="navbar-nav mr-auto">
        <ol class="breadcrumb ol-sf-1 ol-nav">
          <li class="breadcrumb-item">
            <a *ngIf="loggedInUser?.permissions.isMckayUser"
               routerLink="/mckay/{{loggedInUser?.company.uniqid}}">Home</a>
            <a *ngIf="!loggedInUser?.permissions.isMckayUser"
               routerLink="/client/{{loggedInUser?.company.uniqid}}">Home</a>
          </li>
          <li aria-current="page" class="breadcrumb-item">
            List Bandwidth schedules of {{ loggedInUser?.company.name }}
          </li>
        </ol>
      </nav>
    </nav>
    <div *ngIf="loading===false">
      <div class="pb-2 mb-3 border-bottom row">
        <div class="col-md-10">
          <h3 *ngIf="selectedCompany"><b>List Bandwidth schedules of {{ selectedCompany.label }}</b></h3>
          <h3 *ngIf="!selectedCompany"><b>List Bandwidth schedules {{ currentCompany.sugarShortname }} ({{ currentCompany.name }})</b></h3>
        </div>
        <ng-container *ngIf="displayJiraFeature">
          <div class="justify-content-end col-md-2 pl-5">
            <button (click)="openSendJiraPopup()" class="btn btn-link no-padding-button ng-star-inserted jira-button"
                    type="button">
              <i class="fa fa-ticket"></i> Open JIRA trouble ticket
            </button>
          </div>
        </ng-container>
      </div>
      <div *ngIf="successCreateJira" class="alert alert-success alert-dismissible fade show">
        <span *ngFor="let issue of createdJiraIssues; let last = last">
          Jira ticket number {{ issue.code }} created:
          <a href="{{ issue.link }}" target="_blank"> jira link </a><span *ngIf="!last"> &mdash; </span>
        </span>
        <button (click)="successCreateJira = false" aria-label="Close" class="close" type="button">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div *ngIf="error" class="alert alert-danger alert-dismissible fade show">
        An error occurred while processing your request
        <button (click)="error = false" aria-label="Close" class="close" type="button">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div *ngIf="jiraCreationError" class="alert alert-danger alert-dismissible fade show">
        A JIRA ticket could not be created. You may leave this page open and retry later. We are informing the support.
        <button (click)="jiraCreationError = false" aria-label="Close" class="close" type="button">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <p-table #dataTableSchedules [(selection)]="selectedItem" [autoLayout]="false" [columns]=""
               [paginator]="true" [rowsPerPageOptions]="[10, 15, 20, 25, 30, 50, 100, 200, 500, 1000]"
               [rows]="tableItemsPaginationRows" [value]="schedules" selectionMode="single">
        <ng-template pTemplate="caption">
          <button (click)="onClickedResetFilter()" class="buttonResetItem pull-right p-float-label"
                  icon="fa fa-eraser" pButton
                  type="button"></button>
          <div class="p-grid p-fluid">
            <div class="col-12 col-md-3 col-lg-3 text-left">
              <p-floatLabel class="text-left">
                <p-dropdown
                  (onChange)="applyFiltersOnDataTableItem()"
                  [(ngModel)]="userChoicesActiveFiltersSchedules.bundleId"
                  [filter]="true" [options]="formSelectValuesBundles"
                  [showClear]="true"
                  inputId="type"
                  placeholder="All"></p-dropdown>
                <label>
                  Type
                </label>
              </p-floatLabel>
            </div>
            <div class=" col-12 col-md-3 col-lg-3">
              <p-floatLabel>
                <input (input)="applyFiltersOnDataTableItem()"
                       [(ngModel)]="userChoicesActiveFiltersSchedules.contractReferences" pInputText
                       type="text">
                <label>
                  E-tree id
                </label>
              </p-floatLabel>
            </div>
            <div class=" col-12 col-md-3 col-lg-3">
              <p-floatLabel class="text-left">
                <input (input)="applyFiltersOnDataTableItem()"
                       [(ngModel)]="userChoicesActiveFiltersSchedules.crossConnects" pInputText
                       type="text">
                <label>
                  Cross Connect:
                </label>
              </p-floatLabel>
            </div>
            <div class="col-12 col-md-3 col-lg-3 text-left">
              <p-floatLabel>
                <p-multiSelect [(ngModel)]="userChoicesActiveFiltersSchedules.status"
                               (onChange)="applyFiltersOnDataTableItem()"
                               [options]="statusItems" placeholder="Choose a status"
                               optionLabel="label"></p-multiSelect>
                <label>
                  Status
                </label>
              </p-floatLabel>
            </div>
            <div class="row col-12" style="padding-top: 15px;">
              <div *ngIf="loggedInUser?.permissions.isMckayAdminOrMckaySuper===true"
                   class="col-md-4 col-lg-4">
                <label style="float: left; padding-right: 10px; padding-top: 7px;">
                  Account:
                </label>
                <p-treeSelect [(ngModel)]="selectedAccountNodes"
                              [options]="accountTreeNodes"
                              (onNodeSelect)="onAccountSelectionChange()"
                              (onNodeUnselect)="onAccountSelectionChange()"
                              selectionMode="checkbox"
                              [metaKeySelection]="false"
                              [filter]="true"
                              filterBy="label"
                              appendTo="body"
                              panelStyleClass="account-tree-panel"
                              placeholder="All"
                              display="chip"
                              name="accountId"
                              ngDefaultControl>
                  <ng-template pTemplate="header">
                    <div class="treeselect-header-toggle">
                      <p-checkbox [ngModel]="isAllAccountsSelected()"
                                  [binary]="true"
                                  (onChange)="toggleAllAccounts($event)"></p-checkbox>
                      <span>Select All</span>
                    </div>
                  </ng-template>
                </p-treeSelect>
              </div>
              <div *roles="['ROLE_CLIENT']" class="col-md-2 col-lg-2 text-left">
                <p-floatLabel class="text-left">
                  <p-multiSelect [(ngModel)]="userChoicesActiveFiltersSchedules.businessUnit"
                                 (onChange)="applyFiltersOnDataTableItem()"
                                 [options]="businessUnitsList" placeholder="Choose a business unit"
                                 optionLabel="label"></p-multiSelect>
                  <label>
                    Business unit:
                  </label>
                </p-floatLabel>
              </div>
              <div class="col-md-2 col-lg-2">
                <label class="col-3 col-nopad col-form-label float-left">
                  Sps:
                </label>
                <div class="col-3 col-nopad col-form-input float-left" style="padding-top: 7px;">
                  <p-checkbox (onChange)="applyFiltersOnDataTableItem()"
                              [(ngModel)]="userChoicesActiveFiltersSchedules.sps" binary="true"></p-checkbox>
                </div>
              </div>
              <div class="col-md-2 col-lg-2">
                <label class="col-3 col-nopad col-form-label float-left">
                  Mbel:
                </label>
                <div class="col-3 col-nopad col-form-input float-left" style="padding-top: 7px;">
                  <p-checkbox (onChange)="applyFiltersOnDataTableItem()"
                              [(ngModel)]="userChoicesActiveFiltersSchedules.mbel" binary="true"></p-checkbox>
                </div>
              </div>
              <div class="col-md-2 col-lg-2">
                <label class="col-3 col-nopad col-form-label float-left">
                  AD:
                </label>
                <div class="col-3 col-nopad col-form-input float-left" style="padding-top: 7px;">
                  <p-checkbox (onChange)="applyFiltersOnDataTableItem()"
                              [(ngModel)]="userChoicesActiveFiltersSchedules.ad" binary="true"></p-checkbox>
                </div>
              </div>
              <div
                *ngIf="!loggedInUser?.permissions.isMckaySuper || (selectedContractingAccountIds && selectedContractingAccountIds.length>0)"
                class="col-md-2 col-lg-2 row">
                <button (click)="openAllConnectionsList()" class="p-button-success pull-left" icon="fa fa-floppy-o"
                        label="Show all connections"
                        pButton
                        type="submit"></button>
              </div>
              <div *ngIf="!loggedInUser?.permissions.isMckayUser" class=" col-6 col-md-2 col-lg-2 row">
                <button (click)="exportAllEtreesAsJson()" class="p-button-primary pull-left ml-2" icon="fa fa-download"
                        label="Export all e-trees as json"
                        pButton
                        type="submit"></button>
              </div>
            </div>
          </div>

        </ng-template>

        <ng-template let-columns="columns" let-schedule pTemplate="body">
          <p-panel [collapsed]="true" [toggleable]="true" class="mb-3">
            <ng-template pTemplate="header">
              <div style="display: flex; flex-direction: column;">
                <div *ngIf="schedule.contractingAccountName">
                  {{ schedule.contractingAccountName }}
                </div>
                <div style="padding-top: 15px;">Schedule ID: {{ schedule.name }}. Schedule
                  type:{{ schedule.bundleName }}
                  Identification
                  number: {{ schedule.identificationNumber }}
                  &nbsp;&nbsp;<a *roles="['ROLE_MCKAY']" [href]="bwmUrl + '/#/schedule-edit/' + schedule.id"><i
                    aria-hidden="true" class="fa fa-external-link" style="color: #eb9316">edit in BWM
                  </i></a>
                </div>
              </div>

            </ng-template>
            <div class="p-grid">
              <div class="col-6">
                <li *ngIf="schedule.status">Status: {{ schedule.status }}</li>
                <li *ngIf="schedule.masterContractName">Master contract: {{ schedule.masterContractName }}</li>
                <li *ngIf="schedule.contractingAccountName">Contract counter
                  party: {{ schedule.contractingAccountName }}
                </li>
                <li *ngIf="schedule.primaryContactName">Primary contact: {{ schedule.primaryContactName }}</li>
                <li *ngIf="schedule.billinggAccountName">Billing Account: {{ schedule.billinggAccountName }}</li>
                <li *ngIf="schedule.billingContactName">Billing contact: {{ schedule.billingContactName }}</li>
                <li *ngIf="schedule.technicalContactsNames">Technical
                  contact(s): {{ schedule.technicalContactsNames }}
                </li>
                <li *ngIf="schedule.legalContactName">Legal contact: {{ schedule.legalContactName }}</li>
              </div>
              <div *ngIf="authenticationService.userCurrent.permissions.isAdminOrSuperUser" class="col-6">
                <ul>
                  <li *ngIf="schedule.executionDate">Effective date: {{ schedule.executionDate | date:'longDate' }}</li>
                  <li *ngIf="schedule.connectionDate">connection
                    Date: {{ schedule.connectionDate| date:'longDate' }}
                  </li>
                  <li *ngIf="schedule.endDate">Expiration date: {{ schedule.endDate | date:'longDate' }}</li>
                  <li *ngIf="schedule.notificationDate">Notification
                    date: {{ schedule.notificationDate  | date:'longDate' }}
                  </li>
                  <li *ngIf="schedule.pshStart && schedule.pshEnd">Primary service
                    hours: {{ schedule.pshStart | date:'mediumTime' }}
                    - {{ schedule.pshEnd | date:'mediumTime' }}
                  </li>
                  <li *ngIf="schedule.initialTermStartDate">Initial Service start
                    date: {{ schedule.initialTermStartDate  | date:'longDate' }}
                  </li>
                  <li *ngIf="schedule.initialTermEndDate">Initial Service end
                    date: {{ schedule.initialTermEndDate  | date:'longDate' }}
                  </li>
                  <li *ngIf="schedule.initialTerm">Initial Term: {{ schedule.initialTerm }} month(s)</li>
                  <li *ngIf="schedule.noticeDaysInitial">Nb of notice day
                    (initial): {{ schedule.noticeDaysInitial }}
                  </li>
                  <li *ngIf="schedule.renewableStatus">Renewable status: {{ schedule.renewableStatus }}</li>
                  <li *ngIf="schedule.renewalTermStartDate">Renewable Service start
                    date: {{ schedule.renewalTermStartDate  | date:'longDate' }}
                  </li>
                  <li *ngIf="schedule.renewalTermEndDate">Renewable Service end
                    date: {{ schedule.renewalTermEndDate  | date:'longDate' }}
                  </li>
                  <li *ngIf="schedule.renewableTerm">Renewable Term: {{ schedule.renewableTerm }} month(s)</li>
                  <li *ngIf="schedule.noticeDaysRenewal">Nb of notice day
                    (renewal): {{ schedule.noticeDaysRenewal }}
                  </li>
                </ul>
              </div>
            </div>
          </p-panel>
          <p-table *ngIf="schedule.etrees" [autoLayout]="true" [columns]="cols" [value]="schedule.etrees">
            <ng-template let-columns pTemplate="header">
              <tr>
                <th *ngFor="let col of cols" [className]="col.class"
                    [pSortableColumnDisabled]="true" [pSortableColumn]="col.field">
                  {{ col.header }}
                </th>
                <th *ngIf="loggedInUser?.permissions.isMckayUser && schedule.bundleId === clfProductId">Service Type Short</th>
                <th>Actions</th>
              </tr>
            </ng-template>
            <ng-template let-columns="columns" let-etree pTemplate="body">
              <tr *ngIf=" etree.visibleOnfilters !== false" >
                <td style="width: 25%; color: red" [ngClass]="getEtreeRowClass(etree)">
                  <a [href]="'#/schedule/etree/'+etree.id">{{ etree.name }} </a>&nbsp;&nbsp;
                  <a *roles="['ROLE_MCKAY']" [href]="bwmUrl + '/#/etree-edit/' + etree.id">
                    <i aria-hidden="true" class="fa fa-external-link" style="color: #eb9316">
                      edit in BWM
                    </i>
                  </a>
                  &nbsp;&nbsp;<button (click)="gotoAnnoucementPage(etree)"
                                      *ngIf="etree.onGoingAnnouncement && etree.onGoingOutage"
                                      icon="fa fa-exclamation-triangle" pButton pTooltip="Outage" [class]="getClassForCategory(etree.announcementCategory)"
                                      type="button"></button>
                  &nbsp;&nbsp;<button (click)="gotoAnnoucementPage(etree)"
                                      *ngIf="etree.onGoingAnnouncement && !etree.onGoingOutage"
                                      icon="fa fa-wrench" pButton [pTooltip]="getLabelFromAnnouncementCategory(etree.announcementCategory)"
                                      type="button" [class]="getClassForCategory(etree.announcementCategory)"></button>
                </td>
                <td>{{ etree.contractReference }}</td>
                <td>{{ etree.clientReference }}</td>
                <td>
                  <!--                  {{etree.injectionPoint.ccps.xcos}}-->
                  <ul *ngIf="etree.injectionPoint">
                    <li *ngFor="let xco of etree.injectionPoint.ccps.xcos | keyvalue">
                      {{ xco.key }}:{{ xco.value }}
                    </li>
                  </ul>
                </td>
                <td><span *ngIf="etree.bandwidth">{{ etree.bandwidth }} Mbps</span></td>
                <td>{{ etree.activeEtreeInjectionDemarcationPoint?.popShortName }}</td>
                <td>{{ formatArray(etree.receptionPoints) }}</td>
                <td>{{ getDateString(etree.acceptanceDate) }}</td>
                <td>{{ getDateString(etree.deprovisionedDate) }}</td>
                <td>
                  <ul>
                    <li *ngIf="etree.spsEligible">
                      SPS
                    </li>
                    <li *ngIf="etree.isMbelEligible">
                      MBEL
                    </li>
                    <li *ngIf="etree.activeDiversity">
                      AD
                    </li>
                  </ul>
                </td>
                <td *ngIf="loggedInUser?.permissions.isMckayUser && schedule.bundleId === clfProductId">{{ etree.serviceTypeShort }}</td>
                <td class="action-width">
                  <div class="d-flex flex-column">
                    <a [href]="'#/schedule/etree/'+etree.id" style="color: #007bff">Manage etree</a>
                    <button (click)="exportEtreeJsonData(etree)" class="btn btn-link no-padding-button ng-star-inserted"
                            type="button">Export as json
                    </button>
                    <a *ngIf="etree.vvlanId" [href]="'#/bandwidth-graphs/etree/' + etree.vvlanId"
                       style="color: #007bff">
                      View end-to-end graph
                    </a>
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </ng-template>
        <ng-template pTemplate="summary">
          <div class="text-right">
            Total Items: {{ dataTableSchedules.totalRecords }} / {{ schedules?.length }}
          </div>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            No Schedules found
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
<p-dialog [(visible)]="displayAllConnectionList" [baseZIndex]="10000"
          [contentStyle]="{'overflow-y': 'auto', 'overflow-x': 'auto','max-width': '80vw',
                           'max-height': '80vh','min-height':'300px'}"
          [draggable]="false"
          [maximizable]="true"
          [modal]="true"
          [resizable]="true"
          class="connections-table">
  <ng-template pTemplate="header">
    List all connection
    <ng-container *ngIf="!loggedInUser?.permissions.isMckayUser"> for <b>{{ selectedAccountName }}</b></ng-container>
  </ng-template>
  <p-table #dataTableAllConnections *ngIf="allConnections"
           [(selection)]="selectedConnections"
           [autoLayout]="true"
           [columns]="allConnectionsCols"
           [responsive]="true"
           [value]="allConnections.etrees"
           selectionMode="multiple"
  >
    <ng-template pTemplate="header">
      <tr>
        <th *ngIf="loggedInUser?.permissions.isMckayAdminOrMckaySuper">Company</th>
        <th [colSpan]="2">Etree</th>
        <th [colSpan]="7">Injection CCP</th>
        <th [colSpan]="allConnections['receptionPoints'].length">Reception Points</th>
      </tr>
      <tr>
        <th *ngIf="loggedInUser?.permissions.isMckayAdminOrMckaySuper">Company Name</th>
        <th>Etree ID</th>
        <th>Bandwidth product</th>
        <th>Etree Inj. Pop</th>
        <th>Etree BW</th>
        <th>Method</th>
        <th>CrossCo</th>
        <th>BW split</th>
        <th>Tag</th>
        <th>Label</th>
        <th>Reception points</th>
      </tr>
    </ng-template>
    <ng-template let-etree pTemplate="body">

      <tr *ngIf="etree.firstInjectionMethod">
        <td *ngIf="etree.companyName" [rowSpan]="etree.rowSpan">{{ etree.companyName }}</td>
        <td [rowSpan]="etree.rowSpan">{{ etree.etreeId }}</td>
        <td [rowSpan]="etree.rowSpan">{{ etree.etreeBandwidthProduct }}</td>
        <td [rowSpan]="etree.rowSpan">{{ etree.etreeInjectionPop }}</td>
        <td [rowSpan]="etree.rowSpan">{{ etree.etreeBandWidth }} Mbps</td>
        <ng-container *ngIf="etree.firstInjectionMethod">
          <td><b>{{ etree.firstInjectionMethod }}</b></td>
          <td>{{ etree.injectionCcp[etree.firstInjectionMethod]?.xco }}</td>
          <td>{{ etree.injectionCcp[etree.firstInjectionMethod]?.bandwidth }} Mbps</td>
          <td>{{ etree.injectionCcp[etree.firstInjectionMethod]?.tag }}</td>
          <td>{{ etree.injectionCcp[etree.firstInjectionMethod]?.label }}</td>
          <td>
            <ul>
              <ng-container *ngFor="let receptionPop of allConnections['receptionPoints']">
                <ng-container *ngFor="let rdpData of etree['receptionPointsData']">
                  <ng-container *ngIf="rdpData.pop === receptionPop">
                    <ng-container *ngIf="etree.firstInjectionMethod !=='MBEL'">
                      <li>
                        <b>{{ receptionPop }}
                          : {{ etree.firstInjectionMethod }}</b> {{ rdpData[etree.firstInjectionMethod]?.xco }}
                        - {{ rdpData[etree.firstInjectionMethod]?.tag }}
                        - {{ rdpData[etree.firstInjectionMethod]?.label }}
                      </li>
                    </ng-container>
                    <ng-container *ngIf="etree.firstInjectionMethod==='MBEL'">
                      <li>
                        <b>{{ receptionPop }}
                          : {{ etree.firstInjectionMethod }} </b> {{ rdpData[etree.firstInjectionMethod]?.xco }}
                        - {{ rdpData[etree.firstInjectionMethod]?.tag }}
                        - {{ rdpData[etree.firstInjectionMethod]?.label }}
                      </li>
                    </ng-container>
                  </ng-container>
                </ng-container>
              </ng-container>
            </ul>
          </td>
        </ng-container>
      </tr>
      <tr *ngIf="!etree.firstInjectionMethod">
        <td>{{ etree?.companyName }}</td>
        <td>{{ etree?.etreeId }}</td>
        <td>{{ etree?.etreeBandwidthProduct }}</td>
        <td>{{ etree?.etreeInjectionPop }}</td>
        <td>{{ etree?.etreeBandWidth }} Mbps</td>
        <td [colSpan]="5">No injection methode defined</td>
        <td></td>
      </tr>

      <ng-container *ngIf="etree.otherInjectionMethods && etree.otherInjectionMethods.length > 0">
        <ng-container *ngFor="let injectMethod of etree.otherInjectionMethods ">
          <tr>
            <td><b>{{ injectMethod }}</b></td>
            <td>{{ etree.injectionCcp[injectMethod]?.xco }}</td>
            <td>{{ etree.injectionCcp[injectMethod].bandwidth }} Mbps</td>
            <td>{{ etree.injectionCcp[injectMethod].tag }}</td>
            <td>{{ etree.injectionCcp[injectMethod].label }}</td>
            <td>
              <ul>

                <ng-container *ngFor="let receptionPop of allConnections['receptionPoints']">

                  <ng-container *ngFor="let rdpData of etree['receptionPointsData']">
                    <ng-container *ngIf="rdpData.pop === receptionPop">
                      <ng-container *ngIf="injectMethod !=='MBEL' && rdpData[injectMethod] ">
                        <li>
                          <b>{{ receptionPop }}: {{ injectMethod }} </b> {{ rdpData[injectMethod]?.xco }}
                          - {{ rdpData[injectMethod]?.tag }}
                          - {{ rdpData[injectMethod]?.label }}
                        </li>
                      </ng-container>
                      <ng-container *ngIf="injectMethod === 'MBEL' && rdpData[injectMethod]">
                        <li>
                          <b>{{ receptionPop }}: {{ injectMethod }}</b> {{ rdpData[injectMethod]?.xco }}
                          - {{ rdpData[injectMethod]?.tag }}
                          - {{ rdpData[injectMethod]?.label }}
                        </li>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                </ng-container>
              </ul>
            </td>
          </tr>
        </ng-container>
      </ng-container>

    </ng-template>
  </p-table>
  <ng-template pTemplate="footer">
    <button (click)="exportAllConnection()" icon="fa fa-file-o" iconPos="left" label="Export data to Excel file" pButton
            type="button"></button>
  </ng-template>
</p-dialog>

<p-dialog [(visible)]="isJirapopUp"
          [baseZIndex]="10000"
          [contentStyle]="{'overflow-y': 'auto', 'overflow-x': 'auto','max-width': '80vw',
                           'max-height': '80vh','min-height':'300px'}"
          [draggable]="false"
          [maximizable]="true"
          [modal]="true"
          [resizable]="true"
          class="connections-table">
  <ng-template pTemplate="header">
    <div class="row col-md-11">
      <div class="col-md-1 " style="max-width: 4%;">
        <img alt="" class="jira-logo" src="../../../assets/images/logo-jira.png">
      </div>
      <div class="col-md-8 jira-header">
        Create a new Jira issue
      </div>
    </div>
  </ng-template>
  <div class="jira-body">
    <div class="modal-body">
      <p *ngIf="isSendToJiraDisabled">
        <label class="required-items-alert"> Please fill in all required fields</label>
      </p>
      <label *ngIf="loggedInUser" class="custom-label mt-2 mb-2">Reporter: {{ loggedInUser.username }}</label>

      <p-floatLabel>
        <p-multiSelect (onChange)="onSelectProductsUpdateValues()" [(ngModel)]="selectedProdutsForJira"
                       [options]="productsSelectItemsForJira" [panelStyle]="{'width':'95em'}"
                       placeholder="Choose a client product"
                       [styleClass]="'jira-multiSelect'" [style]="{'width':'95em'}" required></p-multiSelect>
        <label class="jira-text">Client Products:</label>
      </p-floatLabel>
      <div *ngIf="displayEtreeDropDown">
        <label class="jira-text">Client Etrees:</label>
        <p-multiSelect (onChange)="onSelectEtreesUpdateValues()" [(ngModel)]="selectedEtreesForJira"
                       [options]="etreeSelectItemsForJira" [panelStyle]="{'width':'95em'}"
                       [placeholder]="'Select Etrees'"
                       [styleClass]="'jira-multiSelect'" [style]="{'width':'95em'}" required></p-multiSelect>
      </div>

      <div *ngIf="displayPopDropDown">
        <label class="jira-text">POPs:</label>
        <p-multiSelect (onChange)="onSelectPop()" [(ngModel)]="selectedPopsForJira" [filter]="true"
                       [options]="popsItemForJira"
                       [panelStyle]="{'width':'95em'}"
                       [placeholder]="'Select Pop'"
                       [style]="{'width':'95em'}" class="p-multiSelect" required></p-multiSelect>
      </div>
      <ng-container *ngIf="selectedPopsForJira">
        <div *ngFor="let pop of selectedPopsForJira;let i = index" class="pop-item">
          <div class="pop-info">
            <label class="jira-text">{{ pop }}</label>
            <span title="Check this box only if you know that there is a physical issue on the cross-connect "> Is there any issue impacting a cross connect?</span>
          </div>
          <p-inputSwitch (onChange)="onPopSwitchChange(i, $event)" class="pop-switch"></p-inputSwitch>
        </div>
      </ng-container>
      <div *ngIf="displayXcoDropDown">
        <label class="jira-text">Cross Connects:</label>
        <p-multiSelect (onChange)="setIsSendToJiraFlag()" [(ngModel)]="selectedXcoForJira"
                       [filter]="true"
                       [options]="crossConnectItemForJira" [panelStyle]="{'width':'95em'}"
                       [placeholder]="'Select Cross Connect'"
                       [style]="{'width':'95em'}" class="p-multiSelect" required></p-multiSelect>
      </div>
      <label class="custom-label mt-2 " for="description">Description:</label>
      <p-editor (onTextChange)="setIsSendToJiraFlag()" [(ngModel)]="jiraCustomDescription" [style]="{ height: '80px' }"
                id="description" name="description" placeholder="Enter the description"></p-editor>
      <label class="jira-text mt-2" for="priority">Priority:</label>
      <select [(ngModel)]="selectedPriority" class="p-dropdown with-icons" id="priority" name="priority">
        <option data-icon="fas fa-life-ring" value="support">Support</option>
        <option data-icon="fas fa-exclamation-triangle" value="urgent">Urgent</option>
      </select>
      <div *roles="['ROLE_CLIENT']" class="mt-2">
        <label class="jira-text">Request participant:</label>
        <p-multiSelect
          [(ngModel)]="selectedParticipantForJira"
          [filter]="true"
          [options]="particpantsItemForJira"
          [panelStyle]="{'width':'95em'}"
          [placeholder]="'Select Participants'"
          [style]="{'width':'95em'}"
          class="p-multiSelect"
          required>
        </p-multiSelect>
      </div>
    </div>
    <div style="display: flex; justify-content: flex-end; align-items: center; margin-top: 1rem;">
      <button (click)="createIssue()" [disabled]=disableCreateIssueButton() class="create-button" appNoDblClick>Send to JIRA
      </button>
      <button (click)="cancel()" class="cancel-button">Cancel</button>
    </div>
  </div>
</p-dialog>


